var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_225_3831",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H21.7092V15.6909H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_225_3831)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.13956 0.256334C5.42385 0.571279 5.39881 1.05779 5.08222 1.34132L2.72231 3.45975H15.5427C18.9469 3.45975 21.7066 6.2113 21.7066 9.60643C21.7066 13.0007 18.9469 15.7531 15.5427 15.7531H5.52803C5.10241 15.7531 4.75755 15.4092 4.75755 14.9847C4.75755 14.5602 5.10241 14.2162 5.52803 14.2162H15.5427C18.0956 14.2162 20.1656 12.1526 20.1656 9.60643C20.1656 7.06028 18.0956 4.99582 15.5427 4.99582H2.72231L5.08222 7.11425C5.39881 7.39778 5.42385 7.88429 5.13956 8.19924C4.85527 8.51499 4.36746 8.53996 4.05168 8.25643L0.517467 5.08442C0.00784951 4.62691 0.00784951 3.82867 0.517467 3.37115L4.05168 0.199144C4.36746 -0.0843869 4.85527 -0.0594168 5.13956 0.256334Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.379167f61530e873ad7352e136940a43.svg";
export { ForwardRef as ReactComponent };